export default {"src":"/_next/static/media/proteinpowder.6be453a6.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};